/* eslint-disable max-len */
/**
 * Awvent - Subscriptions API
 * Awvent Subscriptions Apis
 *
 * OpenAPI spec version: v1
 * Contact: info@prestine.in
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../../../../encoder';

import { Observable }                                        from 'rxjs';
import { environment }                                        from '../../../../../environments/environment';

import { SubscriptionPackageCreateCommand } from '../model/subscriptionPackageCreateCommand';
import { SubscriptionPackageDtoIListWebApiResponse } from '../model/subscriptionPackageDtoIListWebApiResponse';
import { SubscriptionPackageDtoWebApiResponse } from '../model/subscriptionPackageDtoWebApiResponse';
import { SubscriptionPackageUpdatedCommand } from '../model/subscriptionPackageUpdatedCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../../../../variables';
import { Configuration }                                     from '../../../../configuration';


@Injectable()
export class SubscriptionPackageService {

    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    protected basePath = environment.api.subscriptions;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     *
     *
     * @param code
     * @param group
     * @param isActive
     * @param orderBy
     * @param isOrderByDescending
     * @param searchText
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subscriptionPackageGet(code?: string, group?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<SubscriptionPackageDtoIListWebApiResponse>;
    public subscriptionPackageGet(code?: string, group?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscriptionPackageDtoIListWebApiResponse>>;
    public subscriptionPackageGet(code?: string, group?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscriptionPackageDtoIListWebApiResponse>>;
    public subscriptionPackageGet(code?: string, group?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('Code', code as any);
        }
        if (group !== undefined && group !== null) {
            queryParameters = queryParameters.set('Group', group as any);
        }
        if (isActive !== undefined && isActive !== null) {
            queryParameters = queryParameters.set('IsActive', isActive as any);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append('OrderBy', element as any);
            });
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set('IsOrderByDescending', isOrderByDescending as any);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', searchText as any);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SubscriptionPackageDtoIListWebApiResponse>('get',`${this.basePath}/SubscriptionPackage`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subscriptionPackageIdGet(id: string, observe?: 'body', reportProgress?: boolean): Observable<SubscriptionPackageDtoWebApiResponse>;
    public subscriptionPackageIdGet(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscriptionPackageDtoWebApiResponse>>;
    public subscriptionPackageIdGet(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscriptionPackageDtoWebApiResponse>>;
    public subscriptionPackageIdGet(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling subscriptionPackageIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SubscriptionPackageDtoWebApiResponse>('get',`${this.basePath}/SubscriptionPackage/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param xRequestId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subscriptionPackagePost(body?: SubscriptionPackageCreateCommand, xRequestId?: string, observe?: 'body', reportProgress?: boolean): Observable<SubscriptionPackageDtoWebApiResponse>;
    public subscriptionPackagePost(body?: SubscriptionPackageCreateCommand, xRequestId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscriptionPackageDtoWebApiResponse>>;
    public subscriptionPackagePost(body?: SubscriptionPackageCreateCommand, xRequestId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscriptionPackageDtoWebApiResponse>>;
    public subscriptionPackagePost(body?: SubscriptionPackageCreateCommand, xRequestId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            headers = headers.set('x-request-id', String(xRequestId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SubscriptionPackageDtoWebApiResponse>('post',`${this.basePath}/SubscriptionPackage`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subscriptionPackagePut(body?: SubscriptionPackageUpdatedCommand, observe?: 'body', reportProgress?: boolean): Observable<SubscriptionPackageDtoWebApiResponse>;
    public subscriptionPackagePut(body?: SubscriptionPackageUpdatedCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscriptionPackageDtoWebApiResponse>>;
    public subscriptionPackagePut(body?: SubscriptionPackageUpdatedCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscriptionPackageDtoWebApiResponse>>;
    public subscriptionPackagePut(body?: SubscriptionPackageUpdatedCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SubscriptionPackageDtoWebApiResponse>('put',`${this.basePath}/SubscriptionPackage`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
     private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

}
